// The sheet fades rather than hides: he still needs the rooms to know where the tray runs.
export const VEIL_COLOR = "#ffffff";
export const VEIL_OPACITY = 0.7;
/** Far beyond any plan, so the veil covers the sheet without knowing its size. */
export const VEIL_EXTENT = 1_000_000;
export const VEIL_MASK_ID = "karl-tray-veil-mask";

// Edges, not a solid band: he has to see the architect's own tray lines inside it to match ours to them.
export const HIGHLIGHT_EDGE_COLOR = "#2563eb";
export const HIGHLIGHT_TINT_OPACITY = 0.12;
export const HIGHLIGHT_BAND_WIDTH = 70;
export const HIGHLIGHT_EDGE_WIDTH = 7;
export const HIGHLIGHT_PULSE = "1;0.45;1";
